/*
 * @Author: Bai.Zhiming
 * @Date: 2019-6-27
 * @LastEditTime: 2020-02-19 16:10:52
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\iWo\left\personalDraft\personalDraftLeft.js
 * @Description: 个人采写左侧导航
 */

angular.module('personalDraftLeftModule', []).directive('personalDraftLeft', [
    '$state',
    '$timeout',
    function($state, $timeout) {
        return {
            scope: {},
            restrict: 'E',
            replace: true,
            templateUrl: './editingCenter/iWo/left/personalDraft/personalDraftLeft_tpl.html',
            link(scope, $element, $attrs) {
                initStatus();

                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    scope.status = {
                        ourRouter: [
                            'personalManuscript',
                            'receivedManuscript',
                            'newspaperAwaitRevise',
                            'newAwaitRevise', // 新媒体渠道待修订
                            'manuscriptArchives',
                            'draftBox',
                            'myShare',
                        ],
                    };
                    autoLocation();
                }

                /**
                 * [autoLocation description] 自动定位
                 * @return {[type]} [description]
                 */
                function autoLocation() {
                    let timer = $timeout(() => {
                        if (!isOurRouter()) {
                            $element.find('li a')[0].click();
                        } else {
                            let routerArray = $state.current.name.split('.');
                            scope.status.selected = routerArray[3];
                        }
                    });
                    scope.$on('$destroy', () => {
                        $timeout.cancel(timer);
                    });
                }

                /**
                 * [isOurRouter description] 判断是否是个人采写的路由
                 * @return {Boolean} [description]
                 */
                function isOurRouter() {
                    let routerArray = $state.current.name.split('.');
                    if (routerArray.length < 4) {
                        return false;
                    }
                    return scope.status.ourRouter.some((item) => item == routerArray[3]);
                }

                /**
                 * [goTo description] 路由跳转
                 * @param  {[type]} routerName [description] 路由名称
                 * @param  {[type]} params     [description] 参数
                 * @return {[type]}            [description]
                 */
                scope.goTo = function(routerName, params) {
                    // 待修改相同路由不同进入方式判断
                    if (routerName === 'newspaperAwaitRevise' && params && params.newrevise) {
                        scope.status.selected = `${routerName}New`;
                    } else {
                        scope.status.selected = routerName;
                    }
                    let router = `front.editctr.iWo.${routerName}`;
                    if (params && params.newrevise) {
                        scope.status.selected = 'newspaperAwaitReviseNewOfNew';
                    }
                    $state.go(router, params, { reload: router });
                };
            },
        };
    },
]);
